import classnames from "classnames";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import {
  BillingContainer,
  UpgradeLowerSection,
  UpgradeUpperSection,
} from "../../../styledComponents/billing";
import {
  CommonGrid,
  CommonText,
  FirstWordRound,
  PageTitle,
} from "../../../styledComponents/common";

const BillingUpperSection = styled(UpgradeUpperSection)`
  grid-template-columns: 200px auto 200px;
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
`;
const BillingLowerSection = styled(UpgradeLowerSection)`
  grid-template-columns: 400px;
  grid-gap: 0;
  padding-top: 15px;

  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;
const PaddlePaymentContainer = styled.div`
  width: 100%;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const LoaderText = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.main.textSecondary};
  margin-top: 30px;
`;

const PaymentLoader = () => (
  <LoaderContainer>
    <ComponentCircleLoader padding="0" />
    <LoaderText>Complete your order by entering the details here...</LoaderText>
  </LoaderContainer>
);

const PaddleCheckout = props => {
  const [isPaddleLoading, setIsPaddleLoading] = useState(false);

  const { appOnboardingState, selectedOrganization, updateDiscountUsedStatus } =
    props;
  const Paddle = window.Paddle;

  const onboardingDiscountCode = appOnboardingState?.discountCode || null;
  const onboardingDiscountExpiresAt =
    appOnboardingState?.discountExpiresAt || null;
  const onboardingDiscountValid = Boolean(
    appOnboardingState?.isCompleted &&
      appOnboardingState?.discountEarned &&
      !appOnboardingState?.discountUsed &&
      onboardingDiscountCode &&
      onboardingDiscountExpiresAt &&
      moment()
        .tz(selectedOrganization?.timezone || "UTC")
        .isBefore(
          moment.tz(
            onboardingDiscountExpiresAt,
            selectedOrganization?.timezone || "UTC",
          ),
        ),
  );

  const loadCallback = () => {
    setIsPaddleLoading(false);
  };

  const successCallback = () => {
    const plan = props.location?.state?.plan;
    if (selectedOrganization?.id && plan?.id && plan?.paddleId) {
      const payload = {
        organization_id: selectedOrganization.id,
        plan_id: plan.id,
      };
      props.updateOrganizationSubscription(payload);

      if (onboardingDiscountValid) {
        updateDiscountUsedStatus(selectedOrganization.id, true);
      }
    }
    setTimeout(() => {
      const userRole =
        selectedOrganization?.role ||
        localStorage.getItem("selected_organization_role") ||
        "";
      if (userRole === "owner" || userRole === "admin") {
        props.history.push("/user/dashboard");
      } else {
        selectedOrganization.type === "service"
          ? props.history.push("/user/jobs")
          : props.history.push("/user/tasks");
      }
    }, 2000);
  };

  useEffect(() => {
    if (props.location?.state?.plan?.organizationId) {
      const { plan } = props.location.state;
      if (plan.paddleId) {
        const email = localStorage.getItem("email");
        const name = localStorage.getItem("user_fullName");

        if (Paddle.Initialized) {
          Paddle.Update({
            // ✅ Fixed: use data.name and correct Paddle Billing event names
            eventCallback: data => {
              console.log("Paddle event:", data);
              if (data.name === "checkout.loaded") {
                loadCallback();
              } else if (data.name === "checkout.completed") {
                successCallback(data);
              }
            },
          });
        }
        Paddle.Checkout.open({
          settings: {
            displayMode: "inline",
            frameTarget: "paddle-checkout",
            frameInitialHeight: "416",
            frameStyle:
              "width: 100%; min-width: 312px; background-color: transparent; border: none;",
            allowLogout: false,
          },
          items: [
            {
              priceId: plan.paddleId,
              quantity: plan.currentUsers > 1 ? plan.currentUsers - 1 : 1,
            },
          ],
          customer: {
            email: email || "",
          },
          // ✅ Fixed: use discountId (lowercase) instead of discountID
          ...(onboardingDiscountValid && onboardingDiscountCode
            ? { discountId: onboardingDiscountCode }
            : {}),
          customData: {
            organizationId: plan.organizationId,
            planId: plan.id,
          },
        });
      }
    } else {
      props.history.goBack();
    }
  }, []);

  return (
    <div className="content">
      <PageTitle>Billing - Checkout</PageTitle>

      <BillingContainer style={{ gridTemplateColumns: "90%" }}>
        <div>
          <BillingUpperSection alignItems="center">
            <BackButtonComponent
              onClick={() => props.history.goBack()}
              subTitle="Go back to payment"
            />
            <CommonGrid
              columns="auto"
              gap="15px"
              justifyContent="center"
              style={{ justifyItems: `center` }}
            >
              <CommonText name title fontSize="20px">
                Payment Details
              </CommonText>
            </CommonGrid>
            <div />
          </BillingUpperSection>
          <BillingLowerSection>
            <PaddlePaymentContainer>
              {isPaddleLoading && <PaymentLoader />}
              <div
                className={classnames(
                  "paddle-checkout",
                  !isPaddleLoading && "loaded",
                )}
              ></div>
            </PaddlePaymentContainer>
          </BillingLowerSection>
        </div>
      </BillingContainer>
    </div>
  );
};

export default PaddleCheckout;
